import React from "react";
import {ValidatorComponent} from "react-material-ui-form-validator";
import {Checkbox, FormControlLabel, FormGroup} from "@mui/material";
import Grid from "@mui/material/Grid";


class AbstractCheckboxValidator extends ValidatorComponent
{



    errorText = () => {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return <p>{this.getErrorMessage()}</p>;
    }


    renderValidatorComponent = () => {

        let value = (typeof(this.props.value) === 'string') ? this.props.value : (this.props.value === true ? 'true' : 'false');
        const { errorMessages, validators, requiredError, xs, sm, label, name, checked, handleChange, validatorListener,  ...rest } = this.props;

        return(
            <FormGroup row id={"checkbox-form-group"}>
                <Grid item xs={xs} sm={sm} >
                    <FormControlLabel
                        control={
                            <Checkbox
                                name={name}
                                checked={checked}
                                onClick={handleChange}
                                value={value}
                                {...rest}
                                ref={(r) => {this.input = r;}}
                            />
                        }
                        label={label}
                    />
                </Grid>
                <Grid item xs={xs} sm={sm} className={"checkbox-error"}>
                    <div style={{ color: 'red', fontWeight: 'bold', marginTop : '-5px' }}>
                        {this.errorText()}
                    </div>
                </Grid>
            </FormGroup>
        )
    }

}

export default AbstractCheckboxValidator
